import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52f2b6bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guest-reg-form" }
const _hoisted_2 = { class: "card mb-4" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Registrierung", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6 col-md-12" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-person" })
], -1))
const _hoisted_9 = { class: "input-group mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-phone" })
], -1))
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-envelope" })
], -1))
const _hoisted_13 = { class: "col-lg-6 col-md-12" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Essenswunsch", -1))
const _hoisted_16 = { class: "col-lg-4 col-md-12" }
const _hoisted_17 = { class: "form-check form-switch mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "normal"
}, "Normal", -1))
const _hoisted_19 = { class: "col-lg-4 col-md-12" }
const _hoisted_20 = { class: "form-check form-switch mb-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "vegan"
}, "Vegan", -1))
const _hoisted_22 = { class: "col-lg-4 col-md-12" }
const _hoisted_23 = { class: "form-check form-switch mb-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "vegetarien"
}, "Vegetarisch", -1))
const _hoisted_25 = {
  class: "form-check form-switch mb-3",
  style: {"margin-top":"18px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "allergien"
}, "Allergien", -1))
const _hoisted_27 = {
  class: "input-group mb-3",
  style: {"margin-top":"31px"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-list-ul" })
], -1))
const _hoisted_29 = { class: "card mb-3" }
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Begleit Personen", -1))
const _hoisted_32 = {
  class: "mb-3",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "col-lg-4 col-md-12" }
const _hoisted_35 = { class: "input-group mb-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-person" })
], -1))
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = { class: "col-lg-2 col-md-6" }
const _hoisted_39 = { class: "form-check form-switch mb-1" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "compnormal"
}, "Normal", -1))
const _hoisted_42 = { class: "form-check form-switch mb-1" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "compvegan"
}, "Vegan", -1))
const _hoisted_45 = { class: "form-check form-switch" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "compvegetarien"
}, "Vegetarisch", -1))
const _hoisted_48 = { class: "col-lg-2 col-md-6" }
const _hoisted_49 = { class: "form-check form-switch mb-3" }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "compallergien"
}, "Allergien", -1))
const _hoisted_52 = { class: "col-lg-3 col-md-11" }
const _hoisted_53 = { class: "input-group mb-3" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-list-ul" })
], -1))
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = { class: "col-1" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-trash" }, null, -1))
const _hoisted_59 = [
  _hoisted_58
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.guest.name === ''}]),
                  placeholder: "Nachname, Vorname",
                  "aria-label": "Nachname, Vorname",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.guest.name) = $event)),
                  required: ""
                }, null, 2), [
                  [_vModelText, _ctx.guest.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.guest.phone === ''}]),
                  placeholder: "Telefon",
                  "aria-label": "Telefon",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.guest.phone) = $event)),
                  required: ""
                }, null, 2), [
                  [_vModelText, _ctx.guest.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.guest.email === ''}]),
                  placeholder: "E-Mail",
                  "aria-label": "E-Mail",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.guest.email) = $event)),
                  required: ""
                }, null, 2), [
                  [_vModelText, _ctx.guest.email]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.guest.normal) = $event)),
                      role: "switch",
                      id: "normal"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.guest.normal]
                    ]),
                    _hoisted_18
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.guest.vegan) = $event)),
                      role: "switch",
                      id: "vegan"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.guest.vegan]
                    ]),
                    _hoisted_21
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.guest.vegetarien) = $event)),
                      role: "switch",
                      id: "vegetarien"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.guest.vegetarien]
                    ]),
                    _hoisted_24
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.guest.allergien) = $event)),
                  role: "switch",
                  id: "allergien"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.guest.allergien]
                ]),
                _hoisted_26
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  placeholder: "Allergien",
                  "aria-label": "Allergien",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.guest.allergien_name) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.guest.allergien_name]
                ])
              ], 512), [
                [_vShow, _ctx.guest.allergien]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-lg",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addCompanion && _ctx.addCompanion(...args))),
              style: {},
              disabled: _ctx.companions.length > 4
            }, " Person Hinzufügen ", 8, _hoisted_33)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companions, (comp, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row companion",
              key: 'comp_'+index
            }, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["form-control", {'is-invalid': comp.name === ''}]),
                    placeholder: "Nachname, Vorname",
                    "aria-label": "Nachname, Vorname",
                    "onUpdate:modelValue": ($event: any) => ((comp.name) = $event),
                    required: ""
                  }, null, 10, _hoisted_37), [
                    [_vModelText, comp.name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((comp.normal) = $event),
                    role: "switch",
                    id: "compnormal"
                  }, null, 8, _hoisted_40), [
                    [_vModelCheckbox, comp.normal]
                  ]),
                  _hoisted_41
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((comp.vegan) = $event),
                    role: "switch",
                    id: "compvegan"
                  }, null, 8, _hoisted_43), [
                    [_vModelCheckbox, comp.vegan]
                  ]),
                  _hoisted_44
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((comp.vegitarien) = $event),
                    role: "switch",
                    id: "compvegetarien"
                  }, null, 8, _hoisted_46), [
                    [_vModelCheckbox, comp.vegitarien]
                  ]),
                  _hoisted_47
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((comp.allergien) = $event),
                    role: "switch",
                    id: "compallergien"
                  }, null, 8, _hoisted_50), [
                    [_vModelCheckbox, comp.allergien]
                  ]),
                  _hoisted_51
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _withDirectives(_createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: "form-control",
                    placeholder: "Allergien",
                    "aria-label": "Allergien",
                    "onUpdate:modelValue": ($event: any) => ((comp.allergien_name) = $event),
                    required: ""
                  }, null, 8, _hoisted_55), [
                    [_vModelText, comp.allergien_name]
                  ])
                ], 512), [
                  [_vShow, comp.allergien]
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("button", {
                  class: "deleteButton",
                  onClick: ($event: any) => (_ctx.removeCompanion(index))
                }, _hoisted_59, 8, _hoisted_57)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-lg",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.createNewConfirm && _ctx.createNewConfirm(...args))),
        style: {}
      }, " Angaben Speichern ")
    ]),
    _createVNode(_component_Toast, {
      modelValue: _ctx.showToast,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showToast) = $event)),
      type: _ctx.toastType,
      message: _ctx.toastMessage
    }, null, 8, ["modelValue", "type", "message"])
  ], 64))
}